import { FC } from "react";
import LABELS from "../../../../constants/labels/pump.labels";
import { useAppSelector } from "../../../../store/hooks/StoreHooks";
import useCollapseFacade from "../../../../facade/collapse.Facade";
import Accordion from "../../../common/accordion";
import EfficiencyCurves from "./efficiency-curves";
import HeadCurves from "./head-curves";
import PowerCurves from "./power-curve";
import { RootState } from "../../../../store/ConfigureStore";
import { useSelector } from "react-redux";

interface PumpPlotProps { }

const PumpPlot: FC<PumpPlotProps> = () => {
  const { loading } = useAppSelector((state) => state?.pump);
  const PumpInputData = useSelector((state: RootState) => state.pump.PumpInput);
  const PumpInputDataCalculated = useSelector(
    (state: RootState) => state.pump.PumpInputCalculated
  );
  const targetFlowRateForPump = useSelector(
    (state: RootState) => state.gasCalculations.GasFinalCalculatedData
  );
  const selectedPumpData = useSelector(
    (state: RootState) => state.pump.SelectedPump
  );
  const schematicData = useSelector(
    (state: RootState) => state.calculations.schematicData
  );
  const fluidDetails = useSelector((state: RootState) => state.fluid);
  const { performanceCurvesPumpCollapse } = useAppSelector(
    (state) => state?.collapse
  );
   const {Chart1Data,Chart2Data, Chart3Data } = useAppSelector(state => state?.pump);

  const { updatePerformanceCurvesPumpCollapse } = useCollapseFacade();

  const handleCollapseChange = (key: boolean) => {
    updatePerformanceCurvesPumpCollapse(key);
  };
  return (
    <>
      <Accordion
        title='Performance curves'
        isOpen={performanceCurvesPumpCollapse}
        onToggle={() => handleCollapseChange(!performanceCurvesPumpCollapse)}
        content={
          <>
            <>
              <div className='flex justify-center items-start p-4 gap-4 w-full'>
                <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2'>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25 text-[14px] font-normal'>
                      {LABELS.pumpSelected}
                    </label>
                    <label className='text-neutral-25'>
                      {selectedPumpData?.pumpName}
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.targetFlowRate}
                    </label>
                    <label className='text-neutral-25'>
                      {targetFlowRateForPump?.preTFV}{" "}
                      {PumpInputData.actNamePump_DesiredFlowRate}
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>{LABELS.finalTDH}</label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated?.pmpFinalTDH}{" "}
                      {PumpInputData.actNamePump_RequiredTDH}
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.operatingFreq}
                    </label>
                    <label className='text-neutral-25'>
                      {fluidDetails.tab3Input?.operatngFreq} Hz
                    </label>
                  </div>
                </div>
                <div className='flex flex-col justify-between items-center border-[1px] border-darkcolor-400 rounded-[8px] w-1/2 align-top'>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>{LABELS.desiredNoStages}</label>
                    <label className='text-neutral-25'>
                      {PumpInputData?.pump_DesrdStges}
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.liftPerStage}
                    </label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated?.ftLftPerStage}
                      <span className="ml-1">{PumpInputData.actNamePump_LiftPerStage}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.totalPower}
                    </label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated?.hPOPPump}
                      <span className="ml-1">{PumpInputData?.actNamePump_HP3500}</span>
                    </label>
                  </div>
                  <div className='flex justify-between items-center py-[9px] px-[24px] w-full border-b-[1px] border-darkcolor-400'>
                    <label className='text-neutral-25'>
                      {LABELS.efficiency}
                    </label>
                    <label className='text-neutral-25'>
                      {PumpInputDataCalculated?.efficiency} <span className="ml-1"> %</span>
                    </label>
                  </div>
                </div>
              </div>

              {Chart1Data.length>0 &&<EfficiencyCurves />}
            </>
            {Chart2Data.length>0 && <HeadCurves />}
            {Chart3Data.length>0 && <PowerCurves />}
          </>
        }
      />
    </>
  );
};

export default PumpPlot;
